module.exports = __webpack_public_path__ + "static/media/talksCardBackAlt.7f0feeed.svg";